import { border, borderBottom, Spacing } from '@mui/system'
import ProBadge, { ProBadgeContainer } from 'components/badges/ProBadge'
import { ReactNode } from 'react'
import { theme } from 'theme'

import * as Styled from './styled'
import BlockOverlay, { BlockOverlayProps } from 'components/BlockOverlay'
import { Box, Grid } from '@mui/material'
import i18n from 'i18n'

interface PopupSectionProps extends BlockOverlayProps {
  title?: string
  titleIcon?: ReactNode
  children: ReactNode
  padding?: string
  withProBadge?: boolean
  pointerEvents?: 'none' | 'all'
  titlePadding?: string
  contentZIndex?: number
  sectionId?: string
  noBottomBorder?: boolean
  popupSectionGap?: number | string
  noTitleLine?: boolean
  simplified?: boolean
}

export default function PopupSection(props: PopupSectionProps) {
  return (
    <Styled.PopupSection
      sx={{
        pointerEvents: props.pointerEvents ?? 'all',
        margin: props.isUiBlocked ? '8px 0px' : undefined,
        padding: props.simplified
          ? '0px'
          : (props.titlePadding ??
            (i18n.dir() === 'ltr'
              ? '0rem 0.5rem 0rem 1rem'
              : '0rem 1rem 0rem 0.5rem')),
        width: '100%'
      }}
      id={props.sectionId}
    >
      <BlockOverlay
        {...props}
        id={`${props.sectionId}-overlay`}
        blockedOverlayLeftOffset={i18n.dir() === 'ltr' ? 12 : 4}
        blockedOverlayRightOffset={i18n.dir() === 'ltr' ? 4 : 12}
        blockedOverlayTopOffset={-2}
        blockedOverlayBottomOffset={-2}
        color="rgb(215, 213, 213)"
      />
      {props.title &&
        (props.withProBadge ? (
          <ProBadgeContainer>
            <Styled.PopupSectionTitle simplified={props.simplified}>
              {props.title}
            </Styled.PopupSectionTitle>
          </ProBadgeContainer>
        ) : (
          <Grid
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            gap={1}
          >
            <Box
              display={'flex'}
              flexDirection={'row'}
              alignContent={'center'}
              alignItems={'center'}
              gap={1}
              width={'100%'}
            >
              <Styled.PopupSectionTitle simplified={props.simplified}>
                {props.title}
              </Styled.PopupSectionTitle>
              {props.titleIcon}
              {props.noTitleLine ||
              props.isUiBlocked ||
              props.simplified ? null : (
                <Box
                  flexGrow={1}
                  height={'1px'}
                  sx={{ backgroundColor: '#e4e4e4' }}
                />
              )}
            </Box>
          </Grid>
        ))}
      <Styled.PopupSectionContent
        padding={props.padding ?? '0.5rem 0rem 0.8rem 0rem'}
        gap={props.popupSectionGap}
        sx={{
          zIndex: props.contentZIndex
        }}
      >
        {props.children}
      </Styled.PopupSectionContent>
      <BlockOverlay
        {...props}
        blockedOverlayLeftOffset={16}
        blockedOverlayRightOffset={16}
        blockedOverlayTopOffset={4}
        blockedOverlayBottomOffset={4}
        color="transparent"
        opacity={1}
        zIndex={2}
      />
    </Styled.PopupSection>
  )
}
